import React from "react";
import HeroSection from "../../components/DashboardSection/HeroSection";
import DashboardTrafficSection from "../../components/DashboardSection/DashboardTrafficSection";
import DashboardBlogTable from "../../components/DashboardSection/DashboardBlogTable";

const Dashboard = () => {
  return (
    <div className="p-4 container-fluid">
      <HeroSection usedfor="Dashboard" />
      <DashboardTrafficSection />
      <DashboardBlogTable />
    </div>
  );
};

export default Dashboard;
